import React, { PropsWithChildren } from 'react';
import { Paper } from '@mui/material';
import { blueGrey, grey } from '@mui/material/colors';

export const StyledContainer = ({ children }: PropsWithChildren<{}>) => (
  <Paper
    sx={{
      gap: '0.5rem',
      display: 'grid',
      padding: '1rem 1.5rem',
      gridTemplateRows: 'auto auto',

      '& .stagesWidgetHeader': {
        gap: '0.3rem',
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: 'auto 1fr auto',

        '& .stagesList': {
          minWidth: 0,
          gap: '1.5rem',
          width: '100%',
          display: 'flex',
          maxHeight: '2rem',
          flexWrap: 'nowrap',
          alignItems: 'center',
          paddingRight: '1rem',
          justifyContent: 'flex-start',

          overflowX: 'auto',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        },

        '& .stagesWidgetHeaderActions': {
          gap: '1rem',
          display: 'flex',
          alignItems: 'center',
        },
      },

      '& .currentStages': {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '0.5rem',
        padding: '0.25rem 0.5rem',
        backgroundColor: grey[50],
        justifyContent: 'space-between',
      },

      '& .attributes': {
        gap: '0.5rem',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',

        '& > div': {
          gap: '0.5rem',
          padding: '1rem',
          display: 'flex',
          borderRadius: '0.5rem',
          flexDirection: 'column',
          border: `1px solid ${blueGrey[100]}`,
        },
      },
    }}
  >
    {children}
  </Paper>
);
